module.exports = __webpack_public_path__ + "assets/img/learn_word.59e7556b.png";